import React from 'react';
// -*- mode: jsx;-*-
/* eslint-disable react/prop-types */
import BreadcrumbControls from './BreadcrumbControls.js';
import { extractBreadcrumbs } from './BreadcrumbUtils.js';
import { Svg } from '../common/Svg.js';
import usePrimarySearchData from './usePrimarySearchData.js';

let Breadcrumb = props => {
    const { projects, searchURL, callbacks } = props;
    const { breadcrumb } = usePrimarySearchData(projects);
    const crumbData = extractBreadcrumbs(breadcrumb, searchURL);

    const crumbs = crumbData.map(
        data => <BreadcrumbItem key={data.crumbName}
            text={data.crumbName}
            paramsToRemove={data.removeParams}
            callbacks={callbacks} />,
    );

    return (
        <div className="active-filters">
            {crumbs}
            <span className="search-tag-controls">
                <BreadcrumbControls {...props} crumbLen={crumbs.length} />
            </span>
        </div>
    );
};
Breadcrumb = React.memo(Breadcrumb);
export default Breadcrumb;

let BreadcrumbItem = ({ callbacks, paramsToRemove, text }) => {
    function removeFilter(event) {
        callbacks.applyFilters(paramsToRemove);
        event.preventDefault();
    }

    function removeFilterOnEnter(event) {
        const ENTER = 13;
        // noinspection JSDeprecatedSymbols
        if (event.keyCode === ENTER || event.charCode === ENTER) {
            this.removeFilter();
        }
    }

    return (
        <div className={'button-secondary small active ' + (text.length > 20 ? 'long' : '')}>
            <span>{text}</span>
            <a href="" aria-label="Remove this filter" onClick={removeFilter} className="remove-filter"
                tabIndex="0" onKeyPress={removeFilterOnEnter}><Svg icon="delete"
                    attributes={{ role: 'presentation' }}/></a>
        </div>
    );
};
BreadcrumbItem = React.memo(BreadcrumbItem);
